// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__3RmqR","description":"PatientConsentPreview_description__2sXo_"};